import { keyframes, SxProps, Theme } from '@mui/material';

const floatingCardEntrance = keyframes`
  0% {
    opacity: 0;
    transform: translateY(20px) scale(0.94);
  }
  60% {
    opacity: 1;
    transform: translateY(-3px) scale(1.015);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

export const floatingCardEntranceSx: SxProps<Theme> = {
  transformOrigin: 'right bottom',
  animation: `${floatingCardEntrance} 0.5s cubic-bezier(0.34, 1.4, 0.64, 1) both`,
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
};
